// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.dropdown-item.active[data-v-02fbd913] {\n    background-color: #272b30;\n}\n.filter-dropdown[data-v-02fbd913] .dropdown-menu {\n    /* Override dropdown CSS to make long dropdowns scrollable and\n        always positioned below the button\n     */\n    max-height: 90vh;\n    overflow-y: auto;\n    top: 48px !important;\n    transform: none !important;\n}\n", ""]);
// Exports
module.exports = exports;
